import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addSchedulerNote } from '@/lib/api/generated/api';
import { taskKeys } from '@/features/tasks/queryKeys';

/**
 * A message to the run's scheduler. It lands in the run's activity feed, and the
 * scheduler's next decision treats it as its main instruction.
 */
export function useAddSchedulerNote(workspaceId: string, taskId: string) {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: async (body) => {
      const response = await addSchedulerNote(workspaceId, taskId, { body });
      if (response.status !== 201) {
        throw new Error('The message could not be sent.');
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: taskKeys.activity(workspaceId, taskId),
      });
    },
  });
}
